// extracted by mini-css-extract-plugin
export default {"root":"Bubble__root--KQnm8","icon":"Bubble__icon--3hC2W","close":"Bubble__close--1cFFu","title":"Bubble__title--3J8ZL","text":"Bubble__text--Ozg5_"};